<template>
    <div class="main-layout__container error-page">
        <div class="error-page__icon">
            <img v-svg-inline src="@/assets/icons/error-warn.svg" />
        </div>

        <div class="error-page__content">
            <h1 class="error-page__title">403. Отказано в доступе</h1>

            <p class="error-page__text">К странице, на которую вы хотите попасть доступ ограничен специальными правами.</p>

            <div class="error-page__button">
                <UISimpleButton @clicked="goToAuctionsListPage">
                    К аукционам
                </UISimpleButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useRouter } from 'vue-router';

    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    defineOptions({
        name: 'Error403',
    });

    const router = useRouter();

    function goToAuctionsListPage(): void {
        router.push({ name: 'AuctionsList' });
    }
</script>

<style scoped lang="scss">
    @use '../error.scss' as *;
</style>
